<template>
  <div class="p-choice">
    <h2 class="p-choice__name">{{ title }}</h2>
    <p class="p-choice__lead">{{ comment }}</p>
    <div v-if="type === 'survey_or_review'" class="p-choice__button">
      <button>{{ postLabel }}</button>
      <button>{{ surveyLabel }}</button>
    </div>
    <div v-else-if="type === 'survey'" class="p-choice__button">
      <button>{{ surveyLabel }}</button>
    </div>
    <div v-else-if="type === 'review'" class="p-choice__button">
      <button>{{ postLabel }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Choice',
  props: {
    type: {
      type: String,
    },
    title: {
      type: String,
      required: true
    },
    comment: {
      type: String,
      required: true
    },
    postLabel: {
      type: String,
      required: true
    },
    surveyLabel: {
      type: String,
      required: true
    },
  },
}
</script>

<style lang="scss" scoped>
  .p-choice {
    $root: #{&};
    padding: 32px;
    border-radius: 10px;
    background-color: #E9446A;
    color: #FFF;
    &:not(:first-child) {
      margin-top: 24px;
    }
    &__name {
      font-weight: bold;
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
    &__lead {
      margin-top: 8px;
      font-size: 14px;
      line-height: 1.71;
      white-space: pre-wrap;
    }
    &__button {
      display: flex;
      margin: 24px -8px 0;
      text-align: center;
      button {
        flex-grow: 1;
        width: 50%;
        margin: 0 8px;
        padding: 14px 16px;
        border-radius: 10px;
        background-color: #FFF;
        color: #E9446A;
        font-weight: bold;
        font-size: 14px;
        line-height: 1.5;
        text-decoration: none;
        transition: .2s;
        &:hover {
          opacity: .8;
        }
      }
    }
  }
</style>
